import { useEffect, useState } from 'react';

import { idStore } from '@pharmaplan/common/helpers/ServiceHandler';
import { adminBookingDetails } from '@pharmaplan/common';

import { FormikProps } from 'formik';
import { useAppSelector } from '../../useAppSelector';

const useExpressBookingDisabled = (formik:FormikProps<any>, formikPharmacistId: string, isBooking:boolean) => {
  const [disabled, setDisabled] = useState(false);
  const bookedDetails = useAppSelector(adminBookingDetails);

  const userId = bookedDetails[idStore.id as keyof typeof bookedDetails];

  useEffect(() => {
    const isDifferent = userId !== formikPharmacistId;
    if (isBooking) {
      formik.setFieldValue('sendEmailToPharmacist', isDifferent);
      formik.setFieldValue('sendEmailToPharmacy', isDifferent);
      setDisabled(isDifferent);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formikPharmacistId, userId]);

  return { disabled };
};

export default useExpressBookingDisabled;
